import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { TipoClasseCreditoService } from 'src/app/services/tipo-classe-credito.service';

@Component({
    selector: 'app-modal-cadastrar-plano-recuperacao-judicial',
    templateUrl: './modal-cadastrar-plano-recuperacao-judicial.component.html',
    styleUrls: ['./modal-cadastrar-plano-recuperacao-judicial.component.scss']
})
export class ModalCadastrarPlanoRecuperacaoJudicialComponent implements OnInit {
    
    constructor(
        public tipoClasseCreditoService: TipoClasseCreditoService,
        private spinner: NgxSpinnerService,
        private toastrService: ToastrService,
    ) { }
    
    ngOnInit(): void {
        this.bindTipoClasseCredito();
    }

    private modalRef: NgbModalRef;

    planoRecuperacaoJudicial: PlanoRecuperacaoJudicial = {
        valorCredito: null,
        vinculacaoDeDivida: null,
        modalidadeDeAmortizacao: null,
        desagio:0,
        valorCreditoComDesagio: 0,
        prazoCarencia: '',
        prazoCarenciaTipo: '',
        prazoPagamentoPagamento: '',
        prazoPagamentoPagamentoTipo: '',
        classeCredito:0,
        abrangeGarantidoresCoobrigados:'',
        credorFornecedorParceiro: '',
        possuiCredorFornecedorParceiro: false,
        observacoes: '',
        dataPedido: null,
        dataHomologacao: null,
        dataPrevistaPagamento: null
    }

    parcelas = [];

    public pagina: number = 1;

    public prazoPagamentoVencimentoLabel: string = 'Prazo de Pagamento';

    listClasseCredito =[]

    listTipoPeriodo = [
        {
            id: 0,
            nome: 'Dias'
        },
        {
            id: 1,
            nome: 'Meses'
        },
        {
            id: 2,
            nome: 'Anos'
        },
    ]

    listSimNao = 
    [
        {id: '', nome:'--'},
        {id: 'S', nome:'Sim'},
        {id: 'N', nome:'Não'},
    ]


    bindTipoClasseCredito() {
        this.tipoClasseCreditoService.getAll().subscribe(res=>{
            this.listClasseCredito = res.data;
        },error=>{
            if (error && error.errors) {
                this.toastrService.error(error.errors[0], 'Atenção', { timeOut: 10000 });
            }
            else {
                this.toastrService.error('Não foi possível buscar os Tipos de Classe do Crédito!', 'Atenção', { timeOut: 10000 });
            }
        });
    }

    recarregarValores(){
        if(this.planoRecuperacaoJudicial.valorCredito)
        {
            this.planoRecuperacaoJudicial.valorCreditoComDesagio = this.planoRecuperacaoJudicial.valorCredito * (this.planoRecuperacaoJudicial.desagio / 100)
        }
    }

    selecionaModalidadeAmortizacao(){          
        this.prazoPagamentoVencimentoLabel = this.planoRecuperacaoJudicial.modalidadeDeAmortizacao != null &&
                                                this.planoRecuperacaoJudicial.modalidadeDeAmortizacao == '5' 
                                                ? 'Prazo de Vencimento' : 'Prazo de Pagamento';
    }

    dismiss() {
        this.modalRef.dismiss();
    }

    diferencaEmMeses(data1: Date, data2: Date): number {
        const ano1 = data1.getFullYear();
        const mes1 = data1.getMonth(); // 0 = Janeiro, 11 = Dezembro
        const ano2 = data2.getFullYear();
        const mes2 = data2.getMonth();
      
        return (ano2 - ano1) * 12 + (mes2 - mes1);
      }

    checkPreConditions(){
        this.toastrService.clear();

        if(this.planoRecuperacaoJudicial.valorCredito == null){
            this.toastrService.warning('Informe o valor do crédito!', 'Atenção');
            return false;
        }

        if(this.planoRecuperacaoJudicial.dataPrevistaPagamento == null){
            this.toastrService.warning('Informe a data prevista do pagamento!', 'Atenção');
            return false;
        }

        if(this.planoRecuperacaoJudicial.prazoPagamentoPagamento == null){
            this.toastrService.warning('Informe o prazo de pagamento!', 'Atenção');
            return false;
        }

        if(this.planoRecuperacaoJudicial.prazoPagamentoPagamentoTipo == null){
            this.toastrService.warning('Informe o prazo de pagamento!', 'Atenção');
            return false;
        }

        return true;
    }

    gerarParcelas(){
        
        if(!this.checkPreConditions()) return;
debugger;
        this.pagina = 2;

        this.parcelas = [];

        const dataPrevistaPagamento = new Date(this.planoRecuperacaoJudicial.dataPrevistaPagamento);
        
        let ultimaDataPrevistaPagamento = new Date(this.planoRecuperacaoJudicial.dataPrevistaPagamento);

        if(this.planoRecuperacaoJudicial.prazoPagamentoPagamentoTipo == '0'){
            ultimaDataPrevistaPagamento.setDate(ultimaDataPrevistaPagamento.getDate() + Number(this.planoRecuperacaoJudicial.prazoPagamentoPagamento))
        }else if(this.planoRecuperacaoJudicial.prazoPagamentoPagamentoTipo == '1'){
            ultimaDataPrevistaPagamento.setMonth(ultimaDataPrevistaPagamento.getMonth() + Number(this.planoRecuperacaoJudicial.prazoPagamentoPagamento))
        }else{
            ultimaDataPrevistaPagamento.setFullYear(ultimaDataPrevistaPagamento.getFullYear() + Number(this.planoRecuperacaoJudicial.prazoPagamentoPagamento))
        }

        const difereca = this.diferencaEmMeses(dataPrevistaPagamento, ultimaDataPrevistaPagamento);

        const valorParcela = parseFloat((this.planoRecuperacaoJudicial.valorCredito / difereca).toFixed(2));

        let acumulador = 0;

        for(let i=0; i<difereca; i++){
            
            let data = new Date(dataPrevistaPagamento);

            data.setMonth(data.getMonth() + i);

            let valor = 0;

            acumulador = parseFloat((acumulador+ valorParcela).toFixed(2));

            if(acumulador > this.planoRecuperacaoJudicial.valorCredito){                
                const diff_acumulador = acumulador - this.planoRecuperacaoJudicial.valorCredito;

                valor = valorParcela - diff_acumulador;
            }else{
                valor = valorParcela;
            }

            const parcela = {
                numero: i+1,
                dataPrevistaPagamento: data,
                valorParcela: valor
            }

            this.parcelas.push(parcela);
        }
    }

    limparParcelas(){
        this.pagina=1;
    }
}
